import { IImageProps } from '@fluentui/react';
import { IPImage, IPImageFit } from 'baseComponents';
import Config from 'services/Config/configService';

export enum DefaultEmptyStateSize {
  Small = 64,
  Medium = 128,
  Large = 256,
}

interface IDefaultEmptyStateImageProps {
  size?: DefaultEmptyStateSize;
}

const DefaultEmptyStateImage = (props: IDefaultEmptyStateImageProps) => {
  const actualSize = props.size || DefaultEmptyStateSize.Medium;

  const imagePropsEmptyState: IImageProps = {
    src: `${Config.getImageURL()}/def-empty-state.png`,
    imageFit: IPImageFit.contain,
    width: actualSize,
    height: actualSize,
  };

  //
  // Main render
  //
  return <IPImage {...imagePropsEmptyState} />;
};

export default DefaultEmptyStateImage;
